// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "DeliverToDrawer" + "." + "41d8dbb3" + ".chunk.css";
};